import React, { useState, useMemo } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from '../../Components/Common/Button'
import { useNavigate } from 'react-router-dom'
import { useCInfiniteQuery } from '../../Services/QueryCache'
import { Text } from '../../Components/Common/Text'
import { deletePrepayment } from './Functions'
import { Modal } from '../../Components/Common/Modal'
import { useAuth } from '../../Provider/AuthProvider'
import { Calendar } from 'primereact/calendar'
import { useCapsule } from '../../State/Functions'
import { cap } from '../../State'
import { columnProps } from '../../Services/Functions'

export const getNestedValue = (obj, path) => path?.split('.')?.reduce((acc, part) => acc?.[part], obj)

export const PrepaymentList = () => {
  const [range, setRange] = useCapsule(cap.lineaOccupataRange)
  const [datesSearch, setDatesSearch] = useState(range)

  const { data: prepayments = [], isSuccess } = useCInfiniteQuery(['prepaymentList', range])
  const [idToDelete, setIdToDelete] = useState('')

  const [modalVisible, setModalVisible] = useState(false)

  const prepaymentToDisplay = useMemo(() => {
    if (!isSuccess) return []
    return prepayments.map(item => ({
      ...item,
      pnr: item?.prepaymentPnrs?.map(({ pnr }) => pnr)?.join(' - ')
    }))
  }, [prepayments, isSuccess])

  const { user = {} } = useAuth()
  const { user: userObj = {} } = user || {}
  const { role, id: userId } = userObj

  const navigate = useNavigate()

  const BtnActionProc = ({ messagesToRead, statusLabel, id, user }) => (
    <Flex row style={{ width: '100%' }}>
      <Button round icon='fa-duotone fa-pen' style={{ marginRight: 10 }} onClick={() => navigate('/prepayment/' + id)} />
      <Button
        round tooltip='Elimina' icon='fa-duotone fa-trash' onClick={() => {
          setIdToDelete(id)
          setModalVisible(true)
        }}
        disabled={user.id !== userId && role !== 'admin'}
      />
    </Flex>
  )

  return (
    <Flex fw>
      <Modal visible={modalVisible} header='Cancellazione attività' onHide={() => setModalVisible(false)}>
        <Flex fw>
          <Text value='Vuoi cancellare questa attività?' />
          <Flex fw row jb style={{ marginTop: 20 }}>
            <Button label='Annulla' icon='fa-duotone fa-xmark' onClick={() => setModalVisible(false)} />
            <Button
              label='Conferma' icon='fa-duotone fa-check' onClick={() => {
                deletePrepayment(idToDelete)
                setModalVisible(false)
              }}
            />
          </Flex>
        </Flex>
      </Modal>
      <Flex fw jb row>
        <div style={{ width: '20%' }} />
        <Text value='Prepagamenti CDS' size={22} bold />
        <Flex ae style={{ width: '20%' }}>
          <Button label='Aggiungi' icon='fa-duotone fa-plus' onClick={() => navigate('/prepayment/new')} />
        </Flex>
      </Flex>
      <Flex fw row style={{ marginTop: 10 }}>
        <Flex style={{ width: '50%', marginLeft: '25%' }}>
          <Calendar
            hideOnRangeSelection
            value={datesSearch} selectionMode='range' onChange={(e) => {
              setDatesSearch(e.value)
              e.value?.filter(Boolean).length === 2 && setRange(e.value)
            }}
            locale='it' dateFormat='dd/mm/yy' style={{ width: 250 }}
          />
        </Flex>
        <Flex je row style={{ width: '25%' }} />
      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' className='TableSignatures' sortField='startDate' sortOrder={1}
        value={prepaymentToDisplay} emptyMessage='Nessuna attività trovata' responsiveLayout='scroll' paginator rows={10}
      >
        {role === 'admin' || role === 'gestoreH24' || role === 'gestoreOperatori' ? <Column field='user.username' {...columnProps('Utente')} /> : null}
        <Column field='pnr' {...columnProps('PNR')} />
        <Column field='startDate' {...columnProps('Data Inizio')} body={(rowData) => new Date(rowData?.startDate).toLocaleString('it-IT')} />
        <Column field='environment.agencyName' {...columnProps('Agenzia')} body={(rowData) => rowData?.environment?.agencyName} />
        <Column style={{ border: 'none', width: 220, height: 15, textAlign: 'center' }} body={(props) => <BtnActionProc {...props} />} />
      </DataTable>
    </Flex>
  )
}
